import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function CategoryManager({ onClose, onChanged }) {
  const [cats, setCats] = useState([]);
  const [newCat, setNewCat] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const load = async () => {
    const { data } = await axios.get('/api/categories');
    setCats(data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!newCat.trim()) return;
    setErr('');
    try {
      await axios.post('/api/categories', { name: newCat.trim() });
      setNewCat('');
      await load();
      onChanged();
    } catch (e) {
      setErr(e.response?.data?.error || 'Error');
    }
  };

  const remove = async id => {
    if (!window.confirm('Delete this job role? Workers in this job role will not be deleted.')) return;
    await axios.delete(`/api/categories/${id}`);
    await load();
    onChanged();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box small" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Manage Job Roles</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="cat-list">
          {cats.map(c => (
            <div key={c.id} className="cat-row">
              <span>{c.name}</span>
              <button className="btn-danger-sm" onClick={() => remove(c.id)}>Delete</button>
            </div>
          ))}
        </div>
        <div className="cat-add">
          <input
            value={newCat}
            onChange={e => setNewCat(e.target.value)}
            placeholder="New job role name"
            onKeyDown={e => e.key === 'Enter' && add()}
          />
          <button className="btn-primary" onClick={add}>Add</button>
        </div>
        {err && <p className="error-msg">{err}</p>}
      </div>
    </div>
  );
}
